module.exports = __webpack_public_path__ + "static/media/lidcore-detection-4.1cc37138.jpg";